import { DateTime } from "luxon"

export class DailyWork {
  technician_id: number
  work_date: string  // yyyy-MM-dd
  work_schedule_status_id: number
  work_order_id: number
  work_order_number: string
  work_schedule_status_description: string
  customer: string
  location_name: string
  latitude_longitude: string
  unit_number: string
  work_order_status_id: number
  
  constructor() {
  }

  static buildOne(obj: any): DailyWork {
    let target: DailyWork = Object.assign(new DailyWork(), obj)
    return target
  }

  static buildMany(objs: any[]): DailyWork[] {
    const lobjs = []
    for (const i in objs) {
      if (objs.hasOwnProperty(i)) {
        lobjs.push(DailyWork.buildOne(objs[i]))
      }
    }
    return lobjs
  }

  // TODO--is this going to work?  NOPE--needs to be refactored
  static filterByDate(daily_work: DailyWork[], date: string, date_format: string) {
    //console.log('filterByDate', date, date_format)
    if (!daily_work || !Array.isArray(daily_work)) daily_work = []    
    const filtered = daily_work.filter((f) => {       
      // use DateTime.now().toISODate() to get the date in ISO format
      const theday = DateTime.fromFormat(date, date_format).toFormat('M/d/yyyy')    
      const due = DateTime.fromISO(f.work_date, { zone: "utc" }).toFormat('M/d/yyyy')   
      //console.log('theday', theday, 'due', due, 'f.work_date', f.work_date)
      return theday === due
    })                
    return filtered
  }

  // TODO--refactor
  static filterByToday(daily_work: DailyWork[]) {    
    //console.log('filterByToday')
    if (!daily_work || !Array.isArray(daily_work)) daily_work = []       
    
    const filtered = daily_work.filter((f) => {       
      // use DateTime.now().toISODate() to get the date in ISO format
      const today = DateTime.now().toFormat('M/d/yyyy')    
      const due = DateTime.fromISO(f.work_date, { zone: "utc" }).toFormat('M/d/yyyy')   
      //console.log('today', today, 'due', due, 'f.work_date', f.work_date)
      return today === due
    })                
    return filtered
  }
}

